"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.forms = void 0;
var _euiThemeCommon = require("@elastic/eui-theme-common");
var _semantic_colors = require("./colors/_semantic_colors");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */
var _forms = {
  background: (0, _euiThemeCommon.computed)(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      backgroundBasePlain = _ref2[0];
    return backgroundBasePlain;
  }, ['colors.backgroundBasePlain']),
  backgroundDisabled: (0, _euiThemeCommon.computed)(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
      backgroundBaseDisabled = _ref4[0];
    return backgroundBaseDisabled;
  }, ['colors.backgroundBaseDisabled']),
  backgroundReadOnly: (0, _euiThemeCommon.computed)(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 1),
      backgroundBaseDisabled = _ref6[0];
    return backgroundBaseDisabled;
  }, ['colors.backgroundBaseDisabled']),
  backgroundFocused: (0, _euiThemeCommon.computed)(function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 1),
      backgroundBasePlain = _ref8[0];
    return backgroundBasePlain;
  }, ['colors.backgroundBasePlain']),
  backgroundAutofilled: (0, _euiThemeCommon.computed)(function (_ref9) {
    var _ref10 = _slicedToArray(_ref9, 1),
      backgroundBasePrimary = _ref10[0];
    return backgroundBasePrimary;
  }, ['colors.backgroundBasePrimary']),
  backgroundDropping: _semantic_colors.SEMANTIC_COLORS.success70Alpha16,
  prependBackground: (0, _euiThemeCommon.computed)(function (_ref11) {
    var _ref12 = _slicedToArray(_ref11, 1),
      backgroundBaseFormsPrepend = _ref12[0];
    return backgroundBaseFormsPrepend;
  }, ['colors.backgroundBaseFormsPrepend']),
  border: (0, _euiThemeCommon.computed)(function (_ref13) {
    var _ref14 = _slicedToArray(_ref13, 1),
      borderBasePlain = _ref14[0];
    return borderBasePlain;
  }, ['colors.borderBasePlain']),
  borderDisabled: (0, _euiThemeCommon.computed)(function (_ref15) {
    var _ref16 = _slicedToArray(_ref15, 1),
      borderBaseDisabled = _ref16[0];
    return borderBaseDisabled;
  }, ['colors.borderBaseDisabled']),
  borderFocused: (0, _euiThemeCommon.computed)(function (_ref17) {
    var _ref18 = _slicedToArray(_ref17, 1),
      borderStrongPrimary = _ref18[0];
    return borderStrongPrimary;
  }, ['colors.borderStrongPrimary']),
  borderInvalid: (0, _euiThemeCommon.computed)(function (_ref19) {
    var _ref20 = _slicedToArray(_ref19, 1),
      borderStrongDanger = _ref20[0];
    return borderStrongDanger;
  }, ['colors.borderStrongDanger']),
  borderHovered: (0, _euiThemeCommon.computed)(function (_ref21) {
    var _ref22 = _slicedToArray(_ref21, 1),
      borderInteractiveFormsHoverPlain = _ref22[0];
    return borderInteractiveFormsHoverPlain;
  }, ['colors.borderInteractiveFormsHoverPlain']),
  borderInvalidHovered: (0, _euiThemeCommon.computed)(function (_ref23) {
    var _ref24 = _slicedToArray(_ref23, 1),
      borderInteractiveFormsHoverDanger = _ref24[0];
    return borderInteractiveFormsHoverDanger;
  }, ['colors.borderInteractiveFormsHoverDanger']),
  borderAutofilled: (0, _euiThemeCommon.computed)(function (_ref25) {
    var _ref26 = _slicedToArray(_ref25, 1),
      borderBasePrimary = _ref26[0];
    return borderBasePrimary;
  }, ['colors.borderBasePrimary']),
  borderAutofilledHovered: (0, _euiThemeCommon.computed)(function (_ref27) {
    var _ref28 = _slicedToArray(_ref27, 1),
      borderStrongPrimary = _ref28[0];
    return borderStrongPrimary;
  }, ['colors.borderStrongPrimary']),
  clearButtonBackground: _semantic_colors.SEMANTIC_COLORS.shade60,
  controlBorder: (0, _euiThemeCommon.computed)(function (_ref29) {
    var _ref30 = _slicedToArray(_ref29, 1),
      borderBaseFormsControl = _ref30[0];
    return borderBaseFormsControl;
  }, ['colors.borderBaseFormsControl']),
  controlBorderSelected: (0, _euiThemeCommon.computed)(function (_ref31) {
    var _ref32 = _slicedToArray(_ref31, 1),
      borderStrongPrimary = _ref32[0];
    return borderStrongPrimary;
  }, ['colors.borderStrongPrimary']),
  controlBorderDisabled: (0, _euiThemeCommon.computed)(function (_ref33) {
    var _ref34 = _slicedToArray(_ref33, 1),
      borderBaseDisabled = _ref34[0];
    return borderBaseDisabled;
  }, ['colors.borderBaseDisabled']),
  controlBackgroundUnselected: 'transparent',
  controlBackgroundDisabled: (0, _euiThemeCommon.computed)(function (_ref35) {
    var _ref36 = _slicedToArray(_ref35, 1),
      backgroundBaseFormsControlDisabled = _ref36[0];
    return backgroundBaseFormsControlDisabled;
  }, ['colors.backgroundBaseFormsControlDisabled']),
  colorHasPlaceholder: (0, _euiThemeCommon.computed)(function (_ref37) {
    var _ref38 = _slicedToArray(_ref37, 1),
      textSubdued = _ref38[0];
    return textSubdued;
  }, ['colors.textSubdued']),
  colorDisabled: (0, _euiThemeCommon.computed)(function (_ref39) {
    var _ref40 = _slicedToArray(_ref39, 1),
      textDisabled = _ref40[0];
    return textDisabled;
  }, ['colors.textDisabled']),
  iconDisabled: (0, _euiThemeCommon.computed)(function (_ref41) {
    var _ref42 = _slicedToArray(_ref41, 1),
      textDisabled = _ref42[0];
    return textDisabled;
  }, ['colors.textDisabled'])
};
var _dark_forms = _objectSpread(_objectSpread({}, _forms), {}, {
  clearButtonBackground: _semantic_colors.SEMANTIC_COLORS.shade90
});
var forms = exports.forms = {
  maxWidth: (0, _euiThemeCommon.computed)(function (_ref43) {
    var _ref44 = _slicedToArray(_ref43, 1),
      base = _ref44[0];
    return (0, _euiThemeCommon.mathWithUnits)(base, function (x) {
      return x * 25;
    });
  }, ['size.base']),
  LIGHT: _forms,
  DARK: _dark_forms
};